firebird.controller('featureFlagsCtrl', [
    '$rootScope',
    '$scope',
    '$window',
    '$timeout',
    '$state',
    'logService',
    'meetingService',
    'attendeeService',
    'storageService',
    'configService',
    'socketService',
    'analyticsWrapperService',
    function (
        $rootScope,
        $scope,
        $window,
        $timeout,
        $state,
        logService,
        meetingService,
        attendeeService,
        storageService,
        configService,
        socketService,
        analyticsWrapperService
    ) {
        var self = this;

        const logger = new LogServiceWrapper(logService, 'featureFlagsCtrl');

        self.isSaving = false;

        self.closeModal = closeModal;

        // localization should apply only to display and tooltip attributes.
        self.options = [
            {
                name: 'iceTransport',
                type: 'checkbox',
                value: 'relay',
                category: 'client',
                keywords: 'diagnostics,connection,problem,relay,turn,mediapath',
                display: 'Use TURN servers',
                tooltip:
                    'Try this in case you are having bad connection problems, but are okay with higher media latency. This forces a relay-only media path.'
            },
            {
                name: 'iceTransportOnTCP',
                type: 'checkbox',
                value: '1',
                category: 'client',
                keywords: 'diagnostics,connection,problem,relay,turn,mediapath,udp,tcp',
                display: 'Use TURN servers on TCP 443',
                tooltip:
                    'Try this if the previous option does not work for you, to force the use of the TURN relay with TCP on port 443 only. This is useful if UDP traffic is blocked by your Internet service provider or virtual private network.'
            },
            {
                name: 'iceTransportOnTCP',
                type: 'checkbox',
                value: '6',
                category: 'client',
                keywords: 'diagnostics,connection,problem,relay,turn,mediapath,auto',
                display: 'Auto-fallback to TCP TURN',
                tooltip:
                    'Try this to automatically force use of TURN servers on TCP 443 after ICE connection gets disconnected five or more times with disconnections occurring less than five minutes apart. Using this allows automatic fallback when the problem is detected repeatedly.'
            },
            {
                name: 'trackCandidates',
                type: 'checkbox',
                value: 'false',
                category: 'client',
                keywords: 'diagnostics,connection,problem,relay,turn,mediapath,candidates',
                display: 'Do not filter out bad ICE candidates',
                tooltip:
                    'By default the client avoids using ICE candidates that are private IP address, mDNS, IPv6 but not relay, and TCP but not relay. This is useful in certain restrictive firewalls or networks, which block STUN and regular TURN candidates. When the client filters out bad candidates, and if no good candidates are found, it automatically falls back to TURN server on TCP 443. Check this flag to disable this feature.'
            },
            {
                name: 'speedtest',
                type: 'checkbox',
                value: 'false',
                category: 'client',
                keywords: 'configurations,connection,problem,speed,setup,delay',
                display: 'Disable speed test',
                tooltip:
                    'Try this in case you experience long call setup delay on poor network condition. This will prevent the initial network speed test done by the client. If you modify this flag, you may need to reload the app.'
            },
            {
                name: 'reuseScreenSDP',
                type: 'checkbox',
                value: 'false',
                category: 'client',
                keywords: 'diagnostics,media,problem,screenshare,sdp,fileplay,mp4',
                display: 'Do not reuse screen share SDP',
                tooltip:
                    'By default the client reuses the SDP from videoroom plugin for screenshare to SIP plugin. This is required for VDI platforms such as VMware or Citrix, but works for other platforms too. The SDP for MP4 file play is not reused. Check this flag to disable this reuse for screenshare.'
            },
            {
                name: 'videocodec',
                type: 'checkbox',
                value: 'h264',
                default: 'vp8',
                category: 'client',
                keywords: 'configurations,cpu,problem,h264,quality,video,codec,feature',
                display: 'Use H264 video codec',
                tooltip:
                    'Try this in case you are having very high CPU usage that you wish to avoid, but are okay with occasional quality issues. Default is to use H264 in most cases anyway.'
            },
            {
                name: 'videocodec',
                type: 'checkbox',
                value: 'vp8',
                category: 'client',
                keywords: 'configurations,cpu,problem,h264,vp8,video,codec',
                display: 'Use VP8 video codec',
                tooltip:
                    'Try this to force VP8, even if H264 is now enabled as default. This is useful to detect if an issue is related to video codec choice or not.'
            },
            {
                name: 'videoLow',
                type: 'checkbox',
                value: 'true',
                category: 'client',
                keywords: 'configurations,cpu,problem,video,quality,resolution,bitrate',
                display: 'Optimized performance mode',
                tooltip:
                    'Try this in case you are having very high CPU usage. This reduces the capture resolution, bitrate and framerate to operate in low performance mode.'
            },
            {
                name: 'useEncodeTime',
                type: 'checkbox',
                value: 'true',
                category: 'client',
                keywords: 'configurations,cpu,problem,video,quality,videolow',
                display: 'Automatic on encode time',
                tooltip:
                    'Try this to switch to low performance mode when video encode time is high. This applied only on browser, not on Unite or Camaro.'
            },
            {
                name: 'videoLowConfig',
                type: 'checkbox',
                value: 'true',
                category: 'client',
                keywords:
                    'diagnostics,cpu,problem,video,graceful,degradation,quality,resolution,bitrate,framerate,simulcast',
                display:
                    'Graceful degradation of webcam publish, and trigger <a class="link feature-flags-request" data="trigger-cpu-metrics-30">30%</a>, <a class="link feature-flags-request" data="trigger-cpu-metrics-60">60%</a>, or <a class="link feature-flags-request" data="trigger-cpu-metrics-80">80%</a> CPU, or <a class="link feature-flags-request" data="trigger-cpu-metrics-reset">reset</a>.',
                tooltip:
                    'Try this to enable graceful degradation of webcam publish in case when high CPU usage is detected in continuous intervals. When triggered, it enables two levels of low performance mode. In level 1, it disables high substream, and controls the bitrate of lower substreams, and in level 2 it disables high substream, and reduces the framerate of lower substreams, and further reduces the bitrate of lower substreams. This behavior is triggered only on Electron/Unite. However, for testing, you can use the CPU event links above to trigger the events manually.'
            },
            {
                name: 'maxVideosSize',
                type: 'checkbox',
                value: '1440x1080',
                category: 'client',
                keywords: 'configurations,cpu,video,quality,size,resolution',
                display: 'Reduce videos box size',
                tooltip:
                    'Try this to reduce the videos display box size to maximum 1440x1080. This can help reduce the CPU usage on the client machine.'
            },
            {
                name: 'videoResolution',
                type: 'checkbox',
                value: '640x360',
                category: 'client',
                keywords: 'configurations,cpu,problem,video,quality,size,resolution,hd',
                display: 'Reduce capture resolution',
                tooltip:
                    'Try this in case you are having high CPU usage. This reduces the capture resolution of your webcam to 640x360 pixels. Default is 1280x720.'
            },
            {
                name: 'videoResolution',
                type: 'checkbox',
                value: '320x180',
                category: 'client',
                keywords: 'configurations,cpu,problem,video,quality,size,resolution,hd',
                display: 'Lowest capture resolution',
                tooltip:
                    'Try this in case you are having very high CPU usage. This reduces the capture resolution of your webcam to 320x180 pixels. Default is 1280x720.'
            },
            {
                name: 'videoResolutionScreen',
                type: 'checkbox',
                value: 'native',
                category: 'client',
                keywords: 'configurations,screen,video,quality,size,blur,resolution,hd',
                display: 'Use native screen resolution',
                tooltip:
                    'Try this to publish at native screen resolution instead of scaling down to 1080p. This can potentially avoid bluriness in the screen share video when sharing large sized screen. If you change this flag, you may need to re-share the screen.'
            },
            {
                name: 'audiocodec',
                type: 'checkbox',
                value: 'pcmu',
                category: 'client',
                keywords: 'configurations,choppy,problem,audio,711,pcmu,narrow,codec',
                display: 'Use G.711 audio codec',
                tooltip:
                    'Force use of telephone-quality G.711 Mu-Law audio codec at 64kb/s and 8kHz. Default is to use OPUS.'
            },
            {
                name: 'audioBitrate',
                type: 'checkbox',
                value: '20000',
                category: 'client',
                keywords: 'configurations,choppy,problem,audio,bitrate,bandwidth',
                display: 'Reduce audio bitrate',
                tooltip: 'Reduce the audio bitrate to 20kb/s to/from your client. Default is 40-55kb/s.'
            },
            {
                name: 'audioBitrate',
                type: 'checkbox',
                value: '120000',
                category: 'client',
                keywords: 'configurations,choppy,problem,audio,bitrate,bandwidth',
                display: 'Increase audio bitrate',
                tooltip: 'Increase the audio bitrate to 120kb/s from your client. Default is 40-55kb/s.'
            },
            {
                name: 'audioStereo',
                type: 'checkbox',
                value: 'true',
                category: 'client',
                keywords: 'configurations,audio,feature,stereo,3d,sound,opus',
                display: 'Enable stereo audio from client',
                tooltip:
                    'Try this to enable stereo audio from the client microphone. The media server may need to be separately configured though.'
            },
            {
                name: 'simulcastEnabled',
                type: 'checkbox',
                value: 'true',
                category: 'client',
                keywords: 'configurations,video,problem,simulcast,bandwidth',
                display: 'Always enable simulcast',
                tooltip:
                    'Force enable simulcast from your client even for two-party call. Default is to enable only for three or more party calls.'
            },
            {
                name: 'simulcastEnabled',
                type: 'checkbox',
                value: 'false',
                category: 'client',
                keywords: 'configurations,video,problem,simulcast,bandwidth',
                display: 'Disable simulcast',
                tooltip:
                    'Force disable simulcast from your client. Default is to enable only for three or more party calls.'
            },
            {
                name: 'useSimulcast2',
                type: 'checkbox',
                value: 'true',
                default: 'false',
                category: 'client,meeting',
                keywords: 'configurations,video,problem,simulcast,bandwidth',
                display: 'Use transceiver-based simulcast',
                tooltip:
                    'Use modern transceiver based simulcast from your client. Default is to use old-style simulcast, due to compatibility with older Chrome versions.'
            },
            {
                name: 'enableSimulcastToggle',
                type: 'checkbox',
                value: 'true',
                default: 'false',
                category: 'client',
                keywords: 'configurations,video,simulcast,performance,screen,bandwidth',
                display: 'Auto-disable simulcast in large meeting',
                tooltip:
                    'If enabled, the client will auto disable simulcast publish on large video meeting where content is shared. The default cutoff to disable is > 12 webcam and to reenable is <= 10 webcam. It does not work with multishare yet.'
            },
            {
                name: 'videoBitrate',
                type: 'checkbox',
                value: 'fixed',
                category: 'client',
                keywords: 'configurations,video,problem,bitrate,bandwidth,auto,adjust',
                display: 'Disable video bitrate adjustment',
                tooltip:
                    'Disable automatic adjustment of publish video bitrate from your client. Default is to adjust it based on network conditions, packet losses and estimated bandwidth.'
            },
            {
                name: 'adjustOnQualityLimitation',
                type: 'checkbox',
                value: 'true',
                category: 'client',
                keywords: 'configurations,video,problem,quality,limitation,resolution,webcam',
                display: 'Lower webcam resolution if quality limited',
                tooltip:
                    'Lower the desired webcam resolution to 360p instead of 720p, when resolution or quality was automatically changed too many times due to CPU or bandwidth.'
            },
            {
                name: 'adjustOnQualityLimitation',
                type: 'checkbox',
                value: 'false',
                category: 'client',
                keywords: 'configurations,video,problem,quality,limitation,resolution,webcam',
                display: 'Do not adjust on quality limited',
                tooltip:
                    'Disable the adjustment in webcam resolution when quality is limited. Use this if you are having issues when the previous flag is enabled elsewhere such as via meeting level flags.'
            },
            {
                name: 'enableAvailableIncomingBitrate',
                type: 'checkbox',
                value: 'true',
                category: 'client',
                keywords: 'configurations,video,problem,quality,bitrate,simulcast,auto,adjust,frozen',
                display: 'Enable incoming bandwidth estimation',
                tooltip:
                    'Enable availableIncomingBitrate is stats for server to client video stream, so that it can be used to adjust simulcast substream selection and receive side bitrate. Enable this if you experience frozen video that recovers in few seconds, or fluctuating bitrate on receive side.'
            },
            {
                name: 'enableAvailableIncomingBitrate',
                type: 'checkbox',
                value: 'false',
                category: 'client',
                keywords: 'configurations,video,problem,quality,bitrate,simulcast,auto,adjust,frozen',
                display: 'Disable incoming bandwidth estimation',
                tooltip:
                    'Disable availableIncomingBitrate is stats. This prevents the client from adjusting the simulcast substream selection and receive side bitrate. Use this if you are having issues when the previous flag is enabled elsewhere such as via meeting level flags.'
            },
            {
                name: 'adjustOnHighBandwidth',
                type: 'checkbox',
                value: 'false',
                category: 'client',
                keywords: 'configurations,video,quality,resolution,bitrate,simulcast,auto,adjust',
                display: 'Avoid high bandwidth to select substream',
                tooltip:
                    'Avoid using high bandwidth as a signal to select higher substream in simulcast video receive. Default is to use downlink bandwidth detection via speed test to adjust the substream selection. Using this flag, you can force it to not increase substream selection on higher bandwidth than 2mb/s.'
            },
            {
                name: 'adjustOnWindowSize',
                type: 'checkbox',
                value: 'true',
                category: 'client',
                keywords: 'configurations,video,quality,resolution,bitrate,simulcast,auto,adjust',
                display: 'Use window size to select substream',
                tooltip:
                    'Enable use of window size to adjust the substream selection in simulcast video receive. Default is to use window size. When enabled, substream selection will take into account window size, especially for grid layout, by reducing or increasing the substream based on display size.'
            },
            {
                name: 'adjustOnWindowSize',
                type: 'checkbox',
                value: 'false',
                category: 'client',
                keywords: 'configurations,video,quality,resolution,bitrate,simulcast,auto,adjust',
                display: 'Avoid window size to select substream',
                tooltip:
                    'Avoid use of window size to adjust the substream selection in simulcast video receive. Default is to use window size. When disabled, substream selection will not use window size, except for an upper limit cutoff for various substreams.'
            },
            {
                name: 'adjustOnVideoLow',
                type: 'checkbox',
                value: 'false',
                category: 'client',
                keywords: 'configurations,video,quality,resolution,simulcast,lpm,low,auto,adjust',
                display: 'Avoid low performance to reduce substream',
                tooltip:
                    'Avoid using low performance mode as a signal to select lower substream in simulcast video receive. Default is to use low performance mode to trigger lower substream especially if video count is more than 10. Using this flag, you can force it to not reduce substream selection when low performance mode is triggered.'
            },
            {
                name: 'adjustOnSlowLink',
                type: 'checkbox',
                value: 'false',
                category: 'client',
                keywords: 'configurations,video,quality,resolution,loss,simulcast,slowlink,auto,adjust',
                display: 'Avoid slowlink to reduce substream',
                tooltip:
                    'Avoid using slow link triggers due to packet loss as a signal to select lower substream in simulcast video receive. Default is to use slowlink events to reduce substream and temporal selection.'
            },
            {
                name: 'adjustMaxCutoff',
                type: 'checkbox',
                value: 'false',
                category: 'client',
                keywords: 'configurations,video,quality,resolution,simulcast,auto,cutoff,adjust',
                display: 'Avoid forcing max-cutoff on substream',
                tooltip:
                    'Avoid enforcing arbitrary maximum video count cutoff on substream and temporal selection with or without large window size. Default is to force an upper limit on such video count cutoffs.'
            },
            {
                name: 'frozenWorkaround',
                type: 'checkbox',
                value: 'true',
                category: 'client',
                keywords: 'configurations,video,problem,reconnect,recover,auto,adjust,frozen',
                display: 'Auto-recover on frozen video',
                tooltip:
                    'When frozen video is detected, automatically attempt to recover - by stopping publish video, and by restarting receive video. It also attempt quick stats collection to allow quick recovery after frozen video is detected.'
            },
            {
                name: 'frozenWorkaround',
                type: 'checkbox',
                value: 'false',
                category: 'client',
                keywords: 'configurations,video,problem,reconnect,recover,auto,adjust,frozen',
                display: 'Disable recovery on frozen video',
                tooltip:
                    'Disable auto-recovery on frozen video. Use this if you are having issues when the previous flag is enabled elsewhere such as via meeting level flags.'
            },
            {
                name: 'frameRate',
                type: 'checkbox',
                value: '15',
                category: 'client',
                keywords: 'configurations,cpu,video,problem,framerate,fps',
                display: 'Reduce capture framerate',
                tooltip:
                    'Reduce the webcam capture framerate to 15fps. Default is to capture at 30fps for VP8 and at 15fps for H264.'
            },
            {
                name: 'frameRate',
                type: 'checkbox',
                value: '30',
                category: 'client',
                keywords: 'configurations,cpu,video,problem,framerate,fps',
                display: 'Increase capture framerate',
                tooltip:
                    'Increase the webcam capture framerate to 30fps. Default is to capture at 30fps for VP8 and at 15fps for H264.'
            },
            {
                name: 'frameRateScreen',
                type: 'checkbox',
                value: '15',
                category: 'client',
                keywords: 'configurations,cpu,screen,framerate,fps,smooth',
                display: 'Increase screen capture framerate',
                tooltip: 'Increase the screen capture framerate to 15fps. Default is to capture at maximum 5fps.'
            },
            {
                name: 'detectScreenAppMute',
                type: 'checkbox',
                value: 'false',
                category: 'client',
                keywords: 'configurations,screen,app,share,minimize,content',
                display: 'Do not treat mute as app minimize',
                tooltip:
                    'Try this to avoid treating mute event on screen share for application as app minimized behavior. Some older versions of Chrome had an issue on Camaro/Unite.'
            },
            {
                name: 'showPicOnAppMin',
                type: 'checkbox',
                value: 'true',
                category: 'client',
                keywords: 'configurations,screen,app,share,minimize,content,snapshot',
                display: 'Show last snapshot on app minimize',
                tooltip:
                    'Try this to enable periodic capture of app share snapshot, and to show the last snapshot on the viewer side when the publisher app is minimized.'
            },
            {
                name: 'cdrDebug',
                type: 'checkbox',
                value: 'true',
                default: 'false',
                category: 'client',
                keywords: 'diagnostics,debug,CDR,stats,metrics',
                display: 'Enable logging CDR',
                tooltip: 'Try this to enable CDR logging, for stats collection, debugging and so on.'
            },
            {
                name: 'sendStats',
                type: 'checkbox',
                value: 'false',
                category: 'client',
                keywords: 'diagnostics,debug,CDR,stats,metrics',
                display: 'Disable stats collection',
                tooltip: 'Try this to disable collecting quality metrics for diagnosis and trends, debugging and so on.'
            },
            {
                name: 'skipLowCpuAlert',
                type: 'checkbox',
                value: 'true',
                default: 'false',
                category: 'client',
                keywords: 'diagnostics,alert,CPU,videolow',
                display: 'Skip alert for low CPU mode',
                tooltip:
                    'Do not show alert for low CPU mode. This is useful to avoid unnecessary alert to interefere with your workflow especially during testing.'
            },
            {
                name: 'statsReduce',
                type: 'checkbox',
                value: 'true',
                default: 'false',
                category: 'client',
                keywords: 'configurations,CDR,stats,metrics,page,pagination,CPU',
                display: 'Reduce stats data for received video',
                tooltip:
                    'Try this to not collect stats data for received video unless the video is enabled. This is useful together with pagination, to avoid unnecessary data collection, analysis and stoarge. This is set bby default.'
            },
            {
                name: 'testlayout',
                type: 'checkbox',
                value: '12',
                category: 'client,deprecated',
                keywords: 'diagnostics,layout,video,spotlight,feature',
                display: 'Test 12 videos layout',
                tooltip:
                    'Try layout of 12 videos. The fake boxes representing attendee videos are added all at once. If you modify this flag, you may need to reload the app.'
            },
            {
                name: 'testlayout',
                type: 'checkbox',
                value: '30,0.5',
                category: 'client,deprecated',
                keywords: 'diagnostics,layout,video,spotlight,feature',
                display: 'Test 30 videos layout',
                tooltip:
                    'Try layout of 30 videos. The fake boxes representing attendee videos are added one after another. If you modify this flag, you may need to reload the app.'
            },
            {
                name: 'testlayout',
                type: 'checkbox',
                value: '200,,,20,R,4',
                category: 'client,deprecated',
                keywords: 'diagnostics,layout,video,spotlight,feature,page,pinning',
                display: 'Test 200 videos layout',
                tooltip:
                    'Try layout of 200 videos with pagination, pinning, portrait, and randomization. The fake boxes representing attendee videos are as URL parameter of testlayout=200,,,20,R,4. If you modify this flag, you may need to reload the app.'
            },
            {
                name: 'layoutPin',
                type: 'checkbox',
                value: 'true',
                default: 'false',
                category: 'client,deprecated',
                keywords: 'features,video,layout,feature,page,pagination,pinning,favorite',
                display:
                    'Enable video pinning, and <a class="link feature-flags-request" data="toggle-layout-pin">toggle pin</a>',
                tooltip:
                    'Try this to mark some attendees as favorites, so that their video if available is shown at the beginning. Use this together with the next pagination flag. Click to toggle pin and select a video to toggle.'
            },
            {
                name: 'layoutPage',
                type: 'checkbox',
                value: 'true',
                default: 'false',
                category: 'client,deprecated',
                keywords: 'features,video,layout,feature,page,pagination,all hands,allhands',
                display: 'Enable pagination view',
                tooltip:
                    'Try this to enable all hands view with pagination of videos. This can also be set via the large video meeting support meeting flag.'
            },
            {
                name: 'layoutPage',
                type: 'checkbox',
                value: 'false',
                category: 'client,deprecated',
                keywords: 'features,video,layout,feature,page,pagination,all hands,allhands',
                display: 'Disable pagination view',
                tooltip:
                    'Try this to disable all hands view with pagination of videos. This allows you to see the layout without pagination, when pagination is enabled via a meeting level flag.'
            },
            {
                name: 'layoutPage',
                type: 'checkbox',
                value: 'lessInGrid:true',
                category: 'client,deprecated',
                keywords: 'configurations,video,layout,feature,page,pagination,less',
                display: 'Show less videos with pagination',
                tooltip:
                    'Try this to enable all hands view with pagination of videos AND to reduce the number of videos in grid and spotlight views. Default will be 12 instead of 30.'
            },
            {
                name: 'layoutPageReuse',
                type: 'checkbox',
                value: 'true',
                default: 'false',
                category: 'client,deprecated',
                keywords: 'configurations,video,layout,feature,page,pagination,reuse,connection',
                display: 'Enable connection reuse for pagination',
                tooltip:
                    'When pagination is enabled, enable reuse of peer connections. Reusing connections improves CPU efficiency at the expense of complex connection logic. Without reuse, each remote video has one connection. With reuse, only displayed videos use a connection, and recycle the connection when not displayed. This is set as default when pagination is enabled.'
            },
            {
                name: 'layoutDebug',
                type: 'checkbox',
                value: 'true',
                category: 'client,deprecated',
                keywords:
                    'diagnostics,video,layout,debug,trace,feature,page,pagination,all hands,allhands,spotlight,gallery,grid,pinning,favorite',
                display:
                    'Enable layout logs, or test features: <ol><li>Show <a class="link feature-flags-request" data="show-layout-allhands">all hands</a>, <a class="link feature-flags-request" data="show-layout-spotlight">spotlight</a> or <a class="link feature-flags-request" data="show-layout-grid">grid</a></li><li>Add <a class="link feature-flags-request" data="test-layout-add-one">one</a> or <a class="link feature-flags-request" data="test-layout-add-five">five</a>, remove <a class="link feature-flags-request" data="test-layout-remove-one">one</a>, <a class="link feature-flags-request" data="test-layout-remove-five">five</a> or <a class="link feature-flags-request" data="test-layout-remove-selected">selected</a></li><li>Toggle <a class="link feature-flags-request" data="test-layout-toggle-self">self</a> or <a class="link feature-flags-request" data="test-layout-toggle-content">content</a></li><li>Click <a class="link feature-flags-request" data="goto-layout-page-previous">previous</a> or <a class="link feature-flags-request" data="goto-layout-page-next">next</a> in all hands</li><li>select <a class="link feature-flags-request" data="set-layout-page-xsmall">xsmall</a>, <a class="link feature-flags-request" data="set-layout-page-small">small</a>, <a class="link feature-flags-request" data="set-layout-page-medium">medium</a>, <a class="link feature-flags-request" data="set-layout-page-large">large</a>, or <a class="link feature-flags-request" data="set-layout-page-xlarge">xlarge</a> size</li><li>flip <a class="link feature-flags-request" data="layout-page-flip-random">random</a> or <a class="link feature-flags-request" data="layout-page-flip-selected">selected</a>, or <a class="link feature-flags-request" data="layout-page-flip-toggle">toggle</a></li><li><a class="link feature-flags-request" data="layout-page-toggle-talker">toggle random talker</a></li></ol>',
                tooltip:
                    'Use the various links here to test layout features such as change, add/remove videos, active talker, random flips, etc.'
            },
            {
                name: 'layoutPage',
                type: 'checkbox',
                value: 'videoSize:medium,includeSelfVideo:false',
                category: 'client',
                keywords: 'features,layout,video,preview,page,pip,picture-in-picture',
                display: 'Picture-in-picture for preview',
                tooltip:
                    'Enable pagination with video size medium, and show self preview video always in picture-in-picture when enabled instead of in the layout. If you change this flag, you may need to reload the app to see any effect.'
            },
            {
                name: 'layoutPreview',
                type: 'checkbox',
                value: 'autohide',
                category: 'client',
                keywords: 'configurations,layout,video,preview,pip,picture-in-picture,autohide',
                display: 'Auto-hide picture-in-picture of preview',
                tooltip:
                    'When picture-in-picture of preview is enabled, auto-hide the preview when other controls hide.'
            },
            {
                name: 'layoutPreview',
                type: 'checkbox',
                value: 'autosize',
                category: 'client',
                keywords: 'configurations,layout,video,preview,pip,picture-in-picture,size',
                display: 'Auto-size picture-in-picture of preview',
                tooltip:
                    'When picture-in-picture of preview is enabled, show preview as small size of 50%, and expand to larger 100% size on mouse hover.'
            },
            {
                name: 'layoutPreview',
                type: 'checkbox',
                value: 'autoblur',
                category: 'client',
                keywords: 'configurations,layout,video,preview,pip,picture-in-picture,blur',
                display: 'Auto-blur picture-in-picture of preview',
                tooltip:
                    'When picture-in-picture of preview is enabled, blur the preview by default, but show again on mouse hover.'
            },
            {
                name: 'layoutPreview',
                type: 'checkbox',
                value: 'auto',
                category: 'client',
                keywords: 'configurations,layout,video,preview,pip,picture-in-picture,size,blur',
                display: 'Auto-adjust picture-in-picture of preview',
                tooltip:
                    'When picture-in-picture for preview is enabled, auto-adjust preview to reduce distraction, but show default on mouse hover. This combined the previous auto-size and auto-blur behavior, in addition to applying lower opacity and grayscale filter on preview to reduce distraction.'
            },
            {
                name: 'layoutSelfPIP',
                type: 'checkbox',
                value: 'true',
                category: 'client',
                keywords: 'configurations,layout,video,preview,pip,picture-in-picture,size',
                display: 'Show picture-in-picture if only preview',
                tooltip:
                    'When only self preview is shown, use picture-in-picture layout. Once more videos show up, use regular layout. This also applies auto-size of the preview. This only applies when layoutPage is set.'
            },
            {
                name: 'layoutSelfPIP',
                type: 'checkbox',
                value: 'false',
                category: 'client',
                keywords: 'configurations,layout,video,preview,pip,picture-in-picture,size',
                display: 'Avoid picture-in-picture preview',
                tooltip: 'Do not use picture-in-picture when self preview is shown.'
            },
            {
                name: 'hideMuteIndicator',
                type: 'checkbox',
                value: 'true',
                category: 'client',
                keywords: 'configurations,mute,indicator,hide,footer',
                display: 'Hide mute indicator in footer',
                tooltip:
                    'Try this to hide the "You are muted" indicator at the bottom, to avoid overlay on top of other important content such as screen share. If you change this flag, you may need to reload the app to see any effect.'
            },
            {
                name: 'hideSideBar',
                type: 'checkbox',
                value: 'true',
                category: 'client',
                keywords: 'configurations,layout,sidebar',
                display: 'Hide sidebar on join',
                tooltip: 'Try this to auto-hide the left side-bar when the call is connected.'
            },
            {
                name: 'qualityBars',
                type: 'checkbox',
                value: 'true',
                category: 'client',
                keywords: 'configurations,quality,bars,indicator,problem,loss,frozen,choppy,audio,video,attendee',
                display: 'Show quality bars in attendee list',
                tooltip:
                    'Try this to enable the experimental quality bars display in attendee list. The quality bars combine the various quality and connectivity metrics from our internal quality monitoring tool to display more accurate and timely quality and connectivity feedback.'
            },
            {
                name: 'qualityBars',
                type: 'checkbox',
                value: 'log:true',
                category: 'client',
                keywords: 'diagnostics,quality,bars,indicator,problem,loss,frozen,choppy,audio,video,logging',
                display: `Enable quality bars logs, or simulate degradation:
                <table class="trigger-quality-bars">
                    <tr attr="reset">
                        <th>
                            <a class="link">Reset</a>
                        </th>
                        <th media="audio">
                            Audio
                        </th>
                        <th media="video">
                            Video
                        </th>
                        <th media="screen">
                            Screen
                        </th>
                    </tr>
                    <tr attr="loss">
                        <td title='Packets lost'>Loss</td>
                        <td media="audio">
                            <a class="link">5%</a>,
                            <a class="link">20%</a>,
                            <a class="link">30%</a>
                        </td>
                        <td media="video">
                            <a class="link">3%</a>,
                            <a class="link">5%</a>,
                            <a class="link">10%</a>
                        </td>
                        <td media="screen">
                            <a class="link">3%</a>,
                            <a class="link">5%</a>,
                            <a class="link">10%</a>
                        </td>
                    </tr>
                    <tr attr="delay">
                        <td title='Delay'>Delay</td>
                        <td media="audio">
                            <a class="link">300ms</a>,
                            <a class="link">600ms</a>,
                            <a class="link">900ms</a>,
                            <a class="link">1200ms</a>
                        </td>
                        <td media="video">
                            <a class="link">90ms</a>,
                            <a class="link">120ms</a>,
                            <a class="link">130ms</a>,
                            <a class="link">150ms</a>
                        </td>
                        <td media="screen">
                            <a class="link">90ms</a>,
                            <a class="link">120ms</a>,
                            <a class="link">130ms</a>,
                            <a class="link">150ms</a>
                        </td>
                    </tr>
                    <tr attr="jitter">
                        <td title='Jitter'>Jitter</td>
                        <td media="audio">
                            <a class="link">100ms</a>,
                            <a class="link">200ms</a>,
                            <a class="link">300ms</a>,
                            <a class="link">400ms</a>
                        </td>
                        <td media="video">
                            <a class="link">50ms</a>,
                            <a class="link">80ms</a>,
                            <a class="link">130ms</a>,
                            <a class="link">150ms</a>
                        </td>
                        <td media="screen">
                            <a class="link">50ms</a>,
                            <a class="link">80ms</a>,
                            <a class="link">130ms</a>,
                            <a class="link">150ms</a>
                        </td>
                    </tr>
                    <tr attr="available-bitrate">
                        <td title='Change bitrate to some percent of available bitrate. Higher the percentage lower will be the quality.'>Available bitrate</td>
                        <td media="audio">
                            <a class="link">110%</a>,
                            <a class="link">120%</a>,
                            <a class="link">130%</a>,
                            <a class="link">150%</a>
                        </td>
                        <td media="video">
                            <a class="link">110%</a>,
                            <a class="link">120%</a>,
                            <a class="link">130%</a>,
                            <a class="link">150%</a>
                        </td>
                        <td media="screen">
                            <a class="link">110%</a>,
                            <a class="link">120%</a>,
                            <a class="link">130%</a>,
                            <a class="link">150%</a>
                        </td>
                    </tr>
                    <tr attr="desired-bitrate">
                        <td title='Change bitrate to some percent of desired bitrate. Lower the percentage lower will be the quality.'>Desired bitrate</td>
                        <td media="audio">
                        </td>
                        <td media="video">
                            <a class="link">70%</a>,
                            <a class="link">60%</a>,
                            <a class="link">50%</a>,
                            <a class="link">40%</a>
                        </td>
                        <td media="screen">
                        </td>
                    </tr>
                    <tr attr="framerate">
                        <td title='Frame rate reduction from desired framerate. Quality will be max when actual and desired framerate are similar (~95%). Lower the percentage lower will be the quality.'>Framerate</td>
                        <td media="audio">
                        </td>
                        <td media="video">
                            <a class="link">90%</a>,
                            <a class="link">80%</a>,
                            <a class="link">70%</a>
                        </td>
                        <td media="screen">
                            <a class="link">90%</a>,
                            <a class="link">80%</a>,
                            <a class="link">70%</a>
                        </td>
                    </tr>
                    <tr attr="frames-lost">
                        <td title='Frames lost due to dropped or not decoded. Higher the value of frames lost lower will be the quality'>Frames lost</td>
                        <td media="audio">
                        </td>
                        <td media="video">
                            <a class="link">10%</a>,
                            <a class="link">20%</a>,
                            <a class="link">30%</a>
                        </td>
                        <td media="screen">
                            <a class="link">10%</a>,
                            <a class="link">20%</a>,
                            <a class="link">30%</a>
                        </td>
                    </tr>
                    <tr attr="area-reduction">
                        <td title='Area reduction of video. Quality will be maximum when the desired resolution and actual resolution are similar   . Higher the difference between these value lower will be the quality.'>Area</td>
                        <td media="audio">
                        </td>
                        <td media="video">
                            <a class="link">20%</a>,
                            <a class="link">30%</a>,
                            <a class="link">50%</a>
                        </td>
                        <td media="screen">
                        </td>
                    </tr>
                    <tr attr="set-quality-bars-ui">
                        <td colspan='2'>Set self quality bars to</td>
                        <td colspan='2'>
                            <a class="link">0</a>,
                            <a class="link">1</a>,
                            <a class="link">2</a>,
                            <a class="link">3</a>,
                            <a class="link">4</a>
                        </td>
                    </tr>
                </table>`,
                tooltip:
                    'Enable logging of quality bar calculations. You can also use the links above to test various scenarios by emulating quality degradation.'
            },
            {
                name: 'copyNotes',
                type: 'static',
                value: 'true',
                category: 'client',
                keywords: 'features,notes,copy,format',
                display:
                    'Formatted notes, <a class="link feature-flags-request" data="copy-notes-text">copy text</a> or <a class="link feature-flags-request" data="copy-notes-html">open to print</a>',
                tooltip:
                    'Try this to copy the notes to clipboard while preserving the format as text or open the notes in a separate web page to print. Make sure the notes tab is open in the left sidebar before you select this. Currently doing a select-copy on the notes tab does not preserve the formatting. Hence, you can use this feature if you want to preserve the formatting.'
            },
            {
                name: 'videoLabels',
                type: 'checkbox',
                value: 'show',
                category: 'client',
                keywords: 'configurations,layout,video,label,page,pinning',
                display: 'Do not hide video labels',
                tooltip:
                    'Try this to always show the video labels, instead of hiding them after a timeout. This is useful for debugging pagination and pinning related layouts.'
            },
            {
                name: 'layoutMethod',
                type: 'checkbox',
                value: 'consistent',
                category: 'client',
                keywords: 'features,layout,video,spotlight,feature',
                display: 'Show consistent video layout',
                tooltip:
                    'Try this for an alternative video layout which spreads the videos more consistently in the spotlight view. Default is to move smaller videos to top or right only. With this flag enabled, the videos are spread all around the spotlight video.'
            },
            {
                name: 'layoutMethod',
                type: 'checkbox',
                value: 'fixed,landscape',
                category: 'client',
                keywords: 'features,layout,video,padding,zoom,fixed,feature',
                display: 'Show fixed video layout',
                tooltip:
                    'Try this for an alternative video layout which keeps the individual video box aspect ratio of 16:9 or 9:16, and avoids zoom-in. Default is to show a flexible layout which minimizes empty space and may zoom-in when needed. This flag only applies to 12 or less videos.'
            },
            {
                name: 'layoutObjectFit',
                type: 'checkbox',
                value: 'contain',
                category: 'client',
                keywords: 'configurations,layout,video,size,feature,padding',
                display: 'Add padding to video instead of zoom-in',
                tooltip:
                    'Try this to use the object-fit of contain instead of cover for webcam videos. By default webcam videos are shown with object-fit of cover, which zooms in if the aspect ratio of the video does not match the aspect ratio of the view. This can cause cropping of video. Check this option if you prefer black padding instead of cropping.'
            },
            {
                name: 'layoutOrder',
                type: 'checkbox',
                value: 'true',
                default: 'false',
                category: 'client',
                keywords: 'configurations,layout,video,order,feature',
                display: 'Video boxes ordered by name',
                tooltip:
                    'Layout the video boxes ordered by name. Depending on the available space and which video is displayed or not, this may or may not result in the same video order for different attendees. If you change this flag, you may need to reload the app to see any effect.'
            },
            {
                name: 'layoutMove',
                type: 'checkbox',
                value: 'true',
                default: 'false',
                category: 'client',
                keywords: 'features,layout,video,move,drag,feature',
                display: 'Allow moving the videos',
                tooltip:
                    'Allow moving the video boxes in the layout. Click and hold for half a second to allow drag-to-move. By default it allows only drag to select-and-zoom.'
            },
            {
                name: 'layoutLock',
                type: 'checkbox',
                value: 'locked',
                default: 'available',
                category: 'meeting,deprecated',
                keywords: 'features,layout,video,lock,host,feature',
                display: 'Host layout lock',
                tooltip:
                    'Locks the video layouts of all the attendees to that of the meeting host. The host then controls the layout for all, and layout change by attendees are disabled.'
            },
            {
                name: 'layoutTrigger',
                type: 'checkbox',
                value: 'dblclick',
                category: 'client',
                keywords: 'configurations,layout,video,change,click,spotlight',
                display: 'Double click layout change',
                tooltip:
                    'Allow change of layout from spotlight to grid, vice-versa, or spotlight selection using a double click. Default is to use single click. If you change this flag, you may need to reload the app.'
            },
            {
                name: 'layoutResize',
                type: 'checkbox',
                value: 'true',
                category: 'client',
                keywords: 'features,layout,video,resize,drag,feature',
                display:
                    'Allow layout resize, and <a class="link feature-flags-request" data="start-resize-layout">actually do resize</a>',
                tooltip:
                    'Allow changing layout size, e.g., space taken by spotlight vs. other videos. To actually do resize, you must be in spotlight layout and have multiple videos displayed, with one large video and other smaller ones.'
            },
            {
                name: 'talkerLayout',
                type: 'checkbox',
                value: 'none',
                category: 'client',
                keywords: 'configurations,layout,video,talker,active,zoom,feature',
                display: 'Disable active talker layout',
                tooltip:
                    'Try this to alter the default active talker behavior in video layout. This disables the change in layout on active talker change.'
            },
            {
                name: 'talkerLayout',
                type: 'checkbox',
                value: 'zoomin',
                category: 'client',
                keywords: 'features,layout,video,talker,active,zoom,feature',
                display: 'Zoom-in active talker',
                tooltip:
                    'Try this to alter the active talker display in video layout. This zooms in to the video of active talker.'
            },
            {
                name: 'layoutRecord',
                type: 'checkbox',
                value: 'true',
                category: 'meeting',
                keywords: 'features,layout,recording,spotlight,feature',
                display:
                    'Allow record layout change (and <a class="link feature-flags-request" data="toggle-spotlight-in-record">toggle spotlight</a>)',
                tooltip:
                    'Allow changing the spotlight layout of recording. Default is to use content share as spotlight. However, this can be used to change any other webcam or content video as spotlight in the recording. Use toggle link to actually toggle spotlight view of a selected video. If it was previously spotlight, then it is restored, and if it not previously spotlight or some other video was spotlight, then the selected one becomes spotlight.'
            },
            {
                name: 'layoutPopout',
                type: 'checkbox',
                value: 'true',
                category: 'client',
                keywords: 'features,layout,video,popout,resize,feature',
                display:
                    'Allow video popout, and actually popout <a class="link feature-flags-request" data="popout-one-video">one video</a> or <a class="link feature-flags-request" data="popout-all-videos">all videos</a>',
                tooltip:
                    'Allow popout of one or all videos from the current window to a new window. To actually popout one video, click on the link and then select a video to popout. To popout all the videos, click on that link. You can have multiple popped out videos at a time. When the popped out window is closed, the videos are automatically restored in the original window.'
            },
            {
                name: 'videoToggle',
                type: 'static',
                category: 'client',
                keywords: 'diagnostics,video,problem,frozen,hide,show,toggle,bandwidth',
                display:
                    'Allow show/hide of videos, or toggle <a class="link feature-flags-request" data="showhide-one-video">one selected video</a>, <a class="link feature-flags-request" data="showhide-remote-content">remote content</a> or <a class="link feature-flags-request" data="showhide-remote-videos">all remote webcams</a>',
                tooltip:
                    'Try this to manually hide the videos such as to save bandwidth. It affects only the received videos, since published video can be toggled using the camera button. For hiding one video, it displays the paused video box, so that it can be restarted again. For show/hide of remote content or all remote videos, it shows/hides the videos boxes too.'
            },
            {
                name: 'pauseOnBackground',
                type: 'checkbox',
                value: 'true',
                category: 'client',
                keywords: 'diagnostics,video,frozen,hide,show,toggle,bandwidth,pause',
                display: `Enable pause videos on background, or trigger <a class="link feature-flags-request" data="trigger-app-background">background</a>/
                <a class="link feature-flags-request" data="trigger-app-foreground">foreground</a>`,
                tooltip:
                    'Try this to pause the received webcam videos when the app goes in background, to optimize the downlink bandwidth usage and decoding performance. Alternatively, simulate the background or foreground event using the links here. Paused videos are blurred in the display, and automatically resumed when the app goes to foreground.'
            },
            {
                name: 'enablePortraitRecord',
                type: 'checkbox',
                value: 'true',
                category: 'client',
                keywords: 'recording,portrait,layout,video,orientation,webcam',
                display: 'Allow portrait mode in record',
                tooltip:
                    'Try this to allow portrait orientation of the webcam from this client in the recording. When enabled, the client sends the captured webcam size to the server, which is then used to detect portrait webcam orientation from any client during recording. If found, then the recording layout is adjusted to accommodate the portrait orientation of the webcam. Note that this feature can be enabled only if at most 12 webcams are in the recording. Also, if no portrait webcam is detected, then the layout is not altered.'
            },
            {
                name: 'videoLoss',
                type: 'checkbox',
                value: 'prompt',
                category: 'client',
                keywords: 'configurations,video,problem,frozen,loss,pause',
                display: 'Pause video on poor network',
                tooltip:
                    'Try this to prompt the user to stop video on poor network condition. By default, on packet losses, the publish video bitrate is reduced and subscribe simulcast substream is changed. If this flag is checked, then packet losses on lowest reduced publish-side bitrate will prompt the user to stop the publish video and pause the received videos.'
            },
            {
                name: 'videoLoss',
                type: 'checkbox',
                value: 'prompt-stop',
                category: 'client',
                keywords: 'configurations,video,problem,frozen,loss,stop',
                display: 'Hide video on poor network',
                tooltip:
                    'Same as previous except that this performs stop/hide of videos instead of pause, and can be re-enabled using all remote webcams link above.'
            },
            {
                name: 'videoOnScreen',
                type: 'checkbox',
                value: 'true',
                category: 'client,deprecated',
                keywords: 'features,video,screen,circle,face,detection',
                display:
                    'Allow video on screen, and toggle <a class="link feature-flags-request" data="showhide-video-on-screen-circle">video circle</a> or <a class="link feature-flags-request" data="showhide-video-on-screen-face">video face</a>; <a class="link feature-flags-request" data="showhide-video-on-screen-expand">expand</a>, <a class="link feature-flags-request" data="showhide-video-on-screen-reduce">reduce</a>, <a class="link feature-flags-request" data="showhide-video-on-screen-move">move</a> or <a class="link feature-flags-request" data="showhide-video-on-screen-drag">toggle drag</a>.',
                tooltip:
                    'Allow showing webcam video on screen with transparent background so that it appears on screen share feed to others. There are two modes - video circle or with background removed. Additionally, you can expand or reduce the size, move or drag the video around on screen. This feature is only available on Unite or Camaro.'
            },
            {
                name: 'multishare',
                type: 'checkbox',
                value: 'true',
                category: 'meeting',
                keywords: 'features,multiple,content,screen,share,multishare,feature',
                display: 'Allow multiple screen share',
                tooltip:
                    'Allow multiple attendees to share screen at the same time. One attendee may share at most one content. Recording layout shows the first content share in spotlight. This is allowed only for screen share, but not for video file share. If you change this flag, you may need to reload the app.'
            },
            {
                name: 'multisharePrompt',
                type: 'checkbox',
                value: 'alert',
                default: 'true',
                category: 'meeting',
                keywords: 'configurations,multiple,content,screen,share,multishare,prompt',
                display: 'Show notification instead of prompt',
                tooltip:
                    'If multiple screen share is enabled above, then this flag will disable the prompt to select add or replace, but allow notifying the new secondary screen share user about the state of her screen share.'
            },
            {
                name: 'enableLogging',
                type: 'static',
                value: 'true',
                category: 'client',
                keywords: 'diagnostics,choppy,problem,audio,debug,jitter,quality,logging,diagnostics,problem',
                display:
                    'Allow extended logging, and toggle <a class="link feature-flags-request" data="set-logging-audiojb-mine">my audio log</a> or <a class="link feature-flags-request" data="set-logging-audiojb-other">another user</a>',
                tooltip:
                    'Try this to enable various extended logging in our system. The audio log is enabled at the media server. For enabling this for other users, select the attendee from the list. This collects useful statistics at the media server to help us diagnose any audio quality issue related to jitter buffer.'
            },
            {
                name: 'enableAudioRecording',
                type: 'static',
                value: 'true',
                category: 'client',
                keywords: 'diagnostics,choppy,problem,audio,debug,jitter,quality,logging,diagnostics,problem',
                display:
                    'Start audio recording of <a class="link feature-flags-request" data="set-logging-audio-record-all">everybody\'s audio</a>',
                tooltip:
                    'Use this to enable debug recording of all or selected users. For enabling this for other users, select the attendee from the list. This collects useful information at the media server to help us diagnose audio quality issues.'
            },
            {
                name: 'brokenMediaSource',
                type: 'checkbox',
                value: 'false',
                category: 'client',
                keywords: 'configurations,device,problem,media,broken,microphone,webcam',
                display: 'Do not detect broken media source',
                tooltip:
                    'Try this to disable detection of broken media source in a meeting. A broken media source is triggered when no media source is found for a media type. When triggered, it prompts the user about the problem and to restart that device.'
            },
            {
                name: 'brokenMediaPath',
                type: 'checkbox',
                value: 'true',
                category: 'client',
                keywords: 'configurations,connection,problem,mediapath,ICE,broken,video',
                display: 'Detect ICE issues and restart',
                tooltip:
                    'Try this to automatically detect and recover from a broken media path where receive traffic is missing on a publish side peer connection. The recovery involves restart of the media path. There may be false positives in some network conditions, in which case your webcam video pubish may keep restarting periodically.'
            },
            {
                name: 'iceRestartOnAudio',
                type: 'checkbox',
                value: '10000',
                category: 'client',
                keywords: 'diagnostics,connection,problem,mediapath,ICE,restart',
                display: 'ICE restart other media on audio restart',
                tooltip:
                    'Try this to ICE restart all other peer connections if not already started within ten seconds duration, after an audio peer connection is ICE restarted. This is useful to co-relate the reconnections of other peer connections when audio peer connection is reconnected.'
            },
            {
                name: 'iceRestart',
                type: 'static',
                category: 'client',
                keywords: 'diagnostics,connection,frozen,video,problem,restart,reconnect',
                display:
                    'To refresh a video, <a class="link feature-flags-request" data="request-keyframe">request keyframe</a>, <a class="link feature-flags-request" data="select-substream">substream</a>, <a class="link feature-flags-request" data="do-ice-restart">ICE restart</a>, <a class="link feature-flags-request" data="restart-video-play">resubscribe</a>, or <a class="link feature-flags-request" data="restart-video-publish">republish</a>',
                tooltip:
                    'Try ICE restart to restart the media path connection in publish or play video. Try request key frame to fetch the key frame from the publisher. Try substream to refresh substream selection of a remote video. Try resubscribe video to stop and play again a remote video. Try republish to force the publisher to stop and start the video as if doing mute and unmute of the video. Clicking on any of these will close this box without saving other settings, and will allow you to select the video once this box closes.'
            },
            {
                name: 'iceRestart',
                type: 'static',
                category: 'client',
                keywords: 'diagnostics,connection,audio,problem,restart,reconnect',
                display:
                    'To refresh audio, do <a class="link feature-flags-request" data="do-ice-restart-audio">ICE restart</a> or <a class="link feature-flags-request" data="audio-mute-unmute">mute/unmute</a>',
                tooltip:
                    'Try ICE restart to restart the media path connection. Try mute/unmute to automatically mute and unmute the audio publish. Clicking on any of these will close this box without saving other settings.'
            },
            {
                name: 'reconnect',
                type: 'static',
                category: 'client',
                keywords: 'diagnostics,connection,server,problem,restart,reconnect',
                display:
                    'To reconnect to meeting server, use <a class="link feature-flags-request" data="do-reconnect-mtg">immediately</a>, or <a class="link feature-flags-request" data="do-reconnect-mtg-10s">after 10s</a>, <a class="link feature-flags-request" data="do-reconnect-mtg-20s">20s</a> or <a class="link feature-flags-request" data="do-reconnect-mtg-40s">40s</a>',
                tooltip:
                    'Try this to reconnect your client to the meeting (application) server at the socket level. You can reconnect immediately or after a delay mentioned above. This is useful for emulating socket disconnection and testing the reconnection behavior.'
            },
            {
                name: 'reconnect',
                type: 'static',
                category: 'client',
                keywords: 'diagnostics,connection,audio,problem,restart,reconnect',
                display:
                    'To reconnect to media server, use <a class="link feature-flags-request" data="do-reconnect-ws">my socket</a>, <a class="link feature-flags-request" data="do-reconnect-sip">my path</a>, <a class="link feature-flags-request" data="do-reconnect-ws-other">another socket</a>, or <a class="link feature-flags-request" data="do-reconnect-sip-other">another path</a>',
                tooltip:
                    'Try this to reconnect your client to the media server at the socket level or the SIP path level. Or click and select another attendee from the attendee list to reconnect them. Use this option very careful on others, as it will reconnect their client, and will disrupt their call experience momentarily.'
            },
            {
                name: 'reconnectOnMute',
                type: 'checkbox',
                value: 'true',
                category: 'client',
                keywords: 'configurations,connection,audio,problem,buzzing,static,noise,reconnect',
                display: 'Force reconnect when someone mutes you',
                tooltip:
                    'Try this to force a reconnect when someone else mutes your audio in a call. This is a workaround for a static noise/buzzing sound problem: to force the attendee to reconnect if it is emitting buzzing or static noise from the microphone, and someone else detects and mutes this attendee. It only applies if the attendee is on Chrome version on or before 81.'
            },
            {
                name: 'enableReclaim',
                type: 'checkbox',
                value: 'true',
                category: 'client',
                keywords: 'diagnostics,connection,server,problem,restart,reconnect,reclaim',
                display: 'Enable session reclaim',
                tooltip:
                    'Try to enable session reclaim from client to media server, to speed up failover when there is websocket disconnect, and there is no other disconnect in peer connections. If reclaim cannot be used, because it was not enabled at the server, or fails due to timeout or any other reason, the client falls back to fully rejoin the media server and all the peer connections. The system may misbehave if the feature is enabled in the server, but not in the client.'
            },
            {
                name: 'timeoutMuteToFIR',
                type: 'checkbox',
                value: '0',
                category: 'client',
                keywords: 'configurations,connection,video,problem,frozen',
                display: 'Disable FIR on mute',
                tooltip:
                    'By default, when an H264 video stream track gets a mute event, the client requests a key frame after six seconds. Try this to disable auto-requesting key frame in such cases.'
            },
            {
                name: 'mediapath',
                type: 'checkbox',
                value: 'sfu',
                default: 'sfu-fs',
                category: 'meeting',
                keywords: 'features,connection,choppy,audio,problem,mediapath,sfu,lip,sync,delay',
                display: 'Use SFU-only media path',
                tooltip:
                    'This forces the audio and video media via SFU-only. Try this if you experience delays in audio or lip sync issues in your meetings or some other audio quality issue. This flag affects only the audio quality, and will likely not affect the video quality. Recording, and mobile or phone participants are not allowed or will not work properly.'
            },
            {
                name: 'e2eeEnabled',
                type: 'checkbox',
                value: 'true',
                default: 'false',
                category: 'meeting,deprecated',
                keywords: 'features,connection,mediapath,sfu,encryption,security,end-to-end,feature',
                display: 'Enable end-to-end encryption',
                tooltip:
                    'This experimental feature uses SFU-only media path, and in addition, enables end-to-end encryption using Chrome insertable streams feature. Similar to the previous flag, recording and mobile or phone participants are not allowed or will not work properly with this flag. If you change this flag, you may need to reload the app.'
            },
            {
                name: 'testvideos',
                type: 'static',
                category: 'client',
                keywords: 'diagnostics,cpu,connection,problem,video,frozen,feature',
                display:
                    '<a class="link feature-flags-request" data="show-video-from-sfu">Show/hide self video from server</a> or <a class="link feature-flags-request" data="show-video-from-mcu">show/hide recording video</a>',
                tooltip:
                    'Click one of these to toggle the video display. Self video allows you to see how others see your video. Recording video shows what is being recorded and in what layout. The recording video feature does not work without the required media server change.'
            },
            {
                name: 'preview',
                type: 'checkbox',
                value: 'no-mirror',
                category: 'client',
                keywords: 'configurations,video,feature,mirror,preview,test',
                display: 'Disable mirroring of self video preview',
                tooltip:
                    'This is useful if you do not want to show mirrored set webcam preview in a call, especially when testing together with other flags that put caption.'
            },
            {
                name: 'videoCanvas',
                type: 'checkbox',
                value: 'caption:{name}',
                category: 'client',
                keywords: 'configurations,video,feature,webcam,caption,name,test',
                display: 'Show name on my webcam',
                tooltip:
                    'This is useful to display name of the user on the webcam stream, so that the recorded video can show which user video it is.'
            },
            {
                name: 'videoCanvas',
                type: 'checkbox',
                value: 'stream:dummy,bgcolor:random,caption:{name}',
                category: 'client',
                keywords: 'diagnostics,video,feature,webcam,dummy,fake,test',
                display: 'Use fake webcam stream for testing',
                tooltip:
                    'This is useful to avoid the real webcam, but use a fake webcam with timer and display name. Thi sis largely used for testing.'
            },
            {
                name: 'faceTrack',
                type: 'checkbox',
                value: 'true',
                category: 'client',
                keywords: 'features,video,feature,face,tracking,detection,webcam,effect',
                display: 'Enable face tracking on your video',
                tooltip:
                    'Try this to zoom your webcam video to keep your face in the center. All others will see your zoomed-in face too. If you change this flag, you may need to reload the app.'
            },
            {
                name: 'touchBar',
                type: 'checkbox',
                value: 'true',
                category: 'client,deprecated',
                keywords: 'features,mac,osx,touchbar,mute,shortcut,feature',
                display: 'Enable OSX touchbar',
                tooltip:
                    'Try this on Unite or Camaro app running on Mac OS X with touch bar to enable short cut buttons in a call such as to toggle microphone, camera or to display labs playground. Note that this is only available on installed app on OSX, and ignored on others.'
            },
            {
                name: 'mediapipe',
                type: 'checkbox',
                value: 'true',
                default: 'false',
                category: 'client',
                keywords: 'configurations,virtual,background,video,blur,framerate,inline,mediapipe,performance,config',
                display: 'Enable mediapipe for background detection',
                tooltip:
                    'Try this to enable mediapipe for background detection to improve performance of virtual background or blur background feature. This may not work on your hardware because it requires modern GPU and recent Chrome. You will need to reload your app if you change this flag.'
            },
            {
                name: 'videoFilterConfig',
                type: 'checkbox',
                value: 'inline',
                default: 'false',
                category: 'client,deprecated',
                keywords:
                    'configurations,virtual,background,video,blur,framerate,inline,latency,delay,detection,config',
                display: 'Enable per-frame background detection',
                tooltip:
                    'Try this to enable per-frame background detection to avoid the delay in webcam captured frame and background detected frame, which causes lag in backgroud when the head or foreground moves, and especially noticeable on low performance machines. You will need to reload your app if you change this flag.'
            },
            {
                name: 'videoFilterConfig',
                type: 'checkbox',
                value: 'origmodel',
                default: 'false',
                category: 'client,deprecated',
                keywords: 'configurations,virtual,background,video,blur,performance,accuracy,config,model,cpu',
                display: 'Original model for background detection',
                tooltip:
                    'Try this to enable original body-pix machine learning model for background detection with lower accuracy for blur, background removal or virtual background feature. The default is to use alternate home-grown model with higher accuracy and lower CPU usage. You will need to reload your app if you change this flag.'
            },
            {
                name: 'videoFilterConfig',
                type: 'checkbox',
                value: 'alt',
                default: 'false',
                category: 'client,deprecated',
                keywords: 'configurations,virtual,background,video,blur,performance,accuracy,config',
                display: 'Alternate config for background detection',
                tooltip:
                    'Try this to enable alternate configuration in original background detection algorithm for blur, background removal or virtual background feature. The original body-pix model is assumed. The alternate configuration will likely improve the detection accuracy at the cost of higher processing power. You will need to reload your app if you change this flag.'
            },
            {
                name: 'videoFilterConfig',
                type: 'checkbox',
                value: 'auto',
                default: 'false',
                category: 'client,deprecated',
                keywords: 'configurations,virtual,background,video,blur,performance,accuracy,auto,adjust,cpu',
                display: 'Auto-adjust background detection accuracy',
                tooltip:
                    'Try this to enable auto-adjust of original background detection accuracy versus CPU performance, based on ongoing measured performance. The original body-pix model is assumed. Enabling this will also prompt you to disable the background detection feature on poor performance. This applies to background blur, background removal or virtual background feature. You will need to reload your app if you change this flag.'
            }
        ];

        // self.options.sort(function (a, b) {
        //     return ('' + a.name).localeCompare(b.name);
        // });

        self.showInlineTooltip = true;
        self.saveClientFlags = true;
        self.searchFilter = 'Features'; // category of '' (all), 'Features', 'Configurations', or 'Diagnostics'.

        self.clientFlags = {};
        self.meetingFlags = {};

        self.isHost = attendeeService.getIsHost(true);

        self.init = init;
        self.cancel = cancel;
        self.save = save;
        self.initSettings = initSettings;
        self.isEqual = isEqual;

        self.showSearchResult = showSearchResult;
        self.saveAdvancedSettings = saveAdvancedSettings;

        self.resetToDefaults = resetToDefaults;
        self.printAllFlags = printAllFlags;

        self.sendFeedback = sendFeedback;

        self.showing = false;

        $timeout(function () {
            initOnce();
            self.init();
            digest();
        }, 0);

        // $scope.$on('showhide-feature-flags', onShowHide);
        $scope.$on('advanced-settings-changed', onAdvancedSettingsChanged);

        // ////////////////////////

        function initOnce() {
            $timeout(function () {
                $window.$('#select-video-background').click(self.onVideoFilterSelect);
                $window.$('#video-background-file-upload').change(self.onVideoFilterFileSelect);
            });

            // toggle display of featue-flags-verbose items on verbose checkbox.
            $window.$('#feature-flags #show-inline-tooltip').click(function () {
                self.showInlineTooltip = !self.showInlineTooltip;
                logService.log('featureFlagsCtrl toggle verbose=' + self.showInlineTooltip);
                saveAdvancedSettingsBox();
                $window.$('#feature-flags').attr('verbose', '' + self.showInlineTooltip);
            });
            $window.$('#feature-flags #save-client-flags').click(function () {
                self.saveClientFlags = !self.saveClientFlags;
                logService.log('featureFlagsCtrl toggle save=' + self.saveClientFlags);
                saveAdvancedSettingsBox();
            });

            $window.$('#feature-flags #feature-flags-search').on('keyup', function () {
                $timeout(function () {
                    self.showSearchResult();
                });
            });
        }

        function init() {
            logService.log('featureFlagsCtrl init');

            $window.$('#feature-flags div.checkbox-container[keywords]').removeAttr('search-result');
            $window.$('#feature-flags #feature-flags-search').val('');

            var deprecated = configService.getServerValue('featureFlags') == '*'; // only via user pair.

            if (!deprecated) {
                $window
                    .$(
                        '#feature-flags div.checkbox-container[category="deprecated"], #feature-flags div.checkbox-container[category="deprecated"] + div.feature-flags-verbose'
                    )
                    .each(function (index, item) {
                        $window.$(item).css('display', 'none');
                    });
            }

            // prepend in reverse order, so that the order is right eventually.
            var size = self.options.length;
            self.options
                .slice()
                .reverse()
                .forEach(function (option, index) {
                    var rindex = size - index - 1;
                    var keywords = option.keywords || 'unknown';
                    var featureIcon = '';
                    var data = (option.title = (option.display || '').split(/[,\(]/)[0]);

                    if (!deprecated && option.category.match(/\bdeprecated\b/)) {
                        // ignore deprecated options.
                        return;
                    }

                    if (keywords.startsWith('features,')) {
                        featureIcon =
                            '<img class="feature-feedback" title="Rate this labs feature and provide feedback" src="/img/redesign/icons/labs-feedback.png" data="' +
                            data +
                            '" />';
                    }

                    if ((option.category || '').match(/\bclient\b/)) {
                        $window
                            .$('#feature-flags #feature-flags-client')
                            .prepend(
                                '<div class="checkbox-container feature-flags-added" keywords="' +
                                    keywords +
                                    '"><input type="checkbox" id="feature-flags-client-' +
                                    rindex +
                                    '"' +
                                    (option.type == 'static' ? ' checked disabled' : '') +
                                    ' title="' +
                                    option.tooltip +
                                    '\n\n?' +
                                    option.name +
                                    '=' +
                                    option.value +
                                    '"><label class="checkbox-label" for="feature-flags-client-' +
                                    rindex +
                                    '">' +
                                    option.display +
                                    '</label>' +
                                    featureIcon +
                                    '</div><div class="feature-flags-verbose feature-flags-added">' +
                                    option.tooltip +
                                    '</div>'
                            );
                        var client = $window.$('#feature-flags #feature-flags-client-' + rindex);
                        client.click(function () {
                            if ($(this).prop('checked')) {
                                self.clientFlags[option.name] = option.value;
                                analyticsWrapperService.eventTrack('Meeting - feature-flags - checked', {
                                    featureFlagsName: option.name,
                                    featureFlagsTitle: option.title || option.display,
                                    featureFlagsCategory: 'client'
                                });
                            } else {
                                delete self.clientFlags[option.name];
                                analyticsWrapperService.eventTrack('Meeting - feature-flags - unchecked', {
                                    featureFlagsName: option.name,
                                    featureFlagsTitle: option.title || option.display,
                                    featureFlagsCategory: 'client'
                                });
                            }
                            self.options.forEach(function (option1, index) {
                                if (
                                    option1.name == option.name &&
                                    option1.category.match(/\bclient\b/) &&
                                    option1 !== option
                                ) {
                                    $window
                                        .$('#feature-flags #feature-flags-client-' + index)
                                        .prop('checked', option1.value == self.clientFlags[option1.name]);
                                }
                            });
                        });
                    }

                    if (self.isHost && (option.category || '').match(/\bmeeting\b/)) {
                        $window
                            .$('#feature-flags #feature-flags-meeting')
                            .prepend(
                                '<div class="checkbox-container feature-flags-added" keywords="' +
                                    keywords +
                                    '"><input type="checkbox" id="feature-flags-meeting-' +
                                    rindex +
                                    '" title="' +
                                    option.tooltip +
                                    '"><label class="checkbox-label" for="feature-flags-meeting-' +
                                    rindex +
                                    '">' +
                                    option.display +
                                    '</label>' +
                                    featureIcon +
                                    '</div><div class="feature-flags-verbose feature-flags-added">' +
                                    option.tooltip +
                                    '</div>'
                            );
                        var meeting = $window.$('#feature-flags #feature-flags-meeting-' + rindex);
                        meeting.click(function () {
                            if ($(this).prop('checked')) {
                                self.meetingFlags[option.name] = option.value;
                                analyticsWrapperService.eventTrack('Meeting - feature-flags - checked', {
                                    featureFlagsName: option.name,
                                    featureFlagsTitle: option.title || option.display,
                                    featureFlagsCategory: 'meeting'
                                });
                            } else {
                                if (option.default !== undefined) {
                                    self.meetingFlags[option.name] = option.default;
                                } else {
                                    delete self.meetingFlags[option.name];
                                }
                                analyticsWrapperService.eventTrack('Meeting - feature-flags - unchecked', {
                                    featureFlagsName: option.name,
                                    featureFlagsTitle: option.title || option.display,
                                    featureFlagsCategory: 'meeting'
                                });
                            }
                        });
                    }
                });

            $timeout(function () {
                $window.$('#feature-flags a.link.feature-flags-request').click(function (event) {
                    var data = event.currentTarget.getAttribute('data');
                    if (data) {
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        $rootScope.$broadcast('feature-flags-request', { type: data });
                    }
                });
                $window.$(`#feature-flags table.trigger-quality-bars a.link`).click(function (event) {
                    event.preventDefault();
                    event.stopImmediatePropagation();

                    var link = event.currentTarget;
                    var type = 'trigger-quality-bars';
                    var media = link.parentNode.getAttribute('media');
                    var attr = link.parentNode.parentNode.getAttribute('attr');
                    var value = null;

                    if (attr === 'reset') {
                        $window.$('#feature-flags table.trigger-quality-bars a.link[selected]').removeAttr('selected');
                    } else if (link.hasAttribute('selected')) {
                        $window.$(link).removeAttr('selected');
                    } else {
                        $window.$(link.parentNode).find('a.link[selected]').removeAttr('selected');
                        $window.$(link).attr('selected', '');
                        value = link.innerText;
                    }

                    $rootScope.$broadcast('feature-flags-request', {
                        type,
                        media,
                        attr,
                        value
                    });
                });
                $window.$('#feature-flags img.feature-feedback').click(function (event) {
                    var data = event.currentTarget.getAttribute('data');
                    if (data) {
                        event.preventDefault();
                        event.stopImmediatePropagation();
                        self.sendFeedback(event.currentTarget.parentNode, data);
                    }
                });
            });

            loadAdvancedSettingsBox();
            self.initSettings();

            $window.$('#feature-flags').attr('verbose', '' + self.showInlineTooltip);

            if (self.searchFilter) {
                self.showSearchResult();
            }

            $timeout(function () {
                $window.$('#feature-flags #feature-flags-search').focus();
            }, 500);
        }

        function saveAdvancedSettingsBox() {
            if (!self.showInlineTooltip || !self.saveClientFlags) {
                var box = {
                    compact: !self.showInlineTooltip || undefined,
                    meeting: (!self.saveClientFlags && meetingService.getMeetingCode()) || undefined
                };
                storageService.set('advancedSettingsBox', JSON.stringify(box));
            } else {
                storageService.remove('advancedSettingsBox');
            }
        }

        function loadAdvancedSettingsBox() {
            var box = JSON.parse(storageService.get('advancedSettingsBox') || '{}');
            if (box.meeting && box.meeting != meetingService.getMeetingCode()) {
                logService.log(
                    'feature-flags delete advancedSettings as for different meeting ' +
                        box.meeting +
                        ' != ' +
                        meetingService.getMeetingCode()
                );
                storageService.remove('advancedSettings');
            }
            logService.log('feature-flags box=' + JSON.stringify(box));
            self.showInlineTooltip = !box.compact;
            self.saveClientFlags = !box.meeting;
        }

        function initSettings() {
            // stored client flags.
            self.clientFlags = deserializeClientFlags(storageService.get('advancedSettings'));

            self.initVideoFilter();

            self.meetingFlags = deserializeMeetingFlags(configService.getSfuPayload());

            self.initE2EE();
        }

        function initE2EE() {
            if (meetingService.e2eeEnabled()) {
                var e2eeOption = self.options.find(function (option) {
                    return option.name === 'e2eeEnabled' && option.category.match(/\bmeeting\b/);
                });
                if (e2eeOption) {
                    $window
                        .$('#feature-flags #feature-flags-meeting-' + self.options.indexOf(e2eeOption))
                        .prop('checked', true);
                }
            }
        }

        function onAdvancedSettingsChanged(e, data) {
            self.meetingFlags = deserializeMeetingFlags(configService.getSfuPayload());
        }

        function deserializeClientFlags(string, noupdate) {
            var flags = JSON.parse(string || '{}');
            var remaining = [];
            Object.keys(flags).forEach(function (attr) {
                var found = false;
                if (attr == 'videoFilter' && !!(flags.videoFilter || '').match(/\bwasm\b/)) {
                    flags.useWasm = true;
                    delete flags[attr];
                    found = true;
                }
                self.options.forEach(function (option, index) {
                    if (option.name == attr && option.value == flags[attr] && option.category.match(/\bclient\b/)) {
                        if (!noupdate) {
                            $window.$('#feature-flags #feature-flags-client-' + index).prop('checked', true);
                        }
                        found = true;
                    }
                });
                if (!found) {
                    remaining.push(attr);
                }
            });

            if (remaining.length > 0) {
                flags.others = remaining
                    .sort()
                    .map(function (attr) {
                        return encodeURIComponent(attr) + '=' + encodeURIComponent('' + flags[attr]);
                    })
                    .join('&');
                remaining.forEach(function (attr) {
                    delete flags[attr];
                });
            }

            return flags;
        }

        function serializeClientFlags(flags) {
            var data = {};
            for (var attr in flags) {
                if (attr == 'useWasm' && flags[attr]) {
                    data.videoFilter = '{"engine":"wasm"}'; // default is webgl when true
                }
            }
            for (var attr1 in flags) {
                if (attr1 != 'others' && attr1 != 'useWasm') {
                    data[attr1] = flags[attr1];
                }
            }
            if (flags.others) {
                flags.others.split('&').map(function (nv) {
                    var index = nv.indexOf('=');
                    var attr = index >= 0 ? nv.substr(0, index) : nv;
                    var value = index >= 0 ? nv.substr(index + 1) : null;
                    data[decodeURIComponent(attr)] = value && decodeURIComponent(value);
                });
            }
            return JSON.stringify(data);
        }

        // if noUpdate is set, then do not update the checkbox DOM.
        function deserializeMeetingFlags(object, noUpdate) {
            var flags = {};
            Object.keys(object).forEach(function (attr) {
                self.options.forEach(function (option, index) {
                    if (option.name == attr && option.category.match(/\bmeeting\b/)) {
                        console.log(
                            'data=',
                            option.name,
                            option.value,
                            object[attr],
                            $window.$('#feature-flags #feature-flags-meeting-' + index).prop('checked')
                        );
                    }
                    if (
                        !noUpdate &&
                        option.name == attr &&
                        option.value == object[attr] &&
                        option.category.match(/\bmeeting\b/)
                    ) {
                        $window.$('#feature-flags #feature-flags-meeting-' + index).prop('checked', true);
                    }
                });
            });
            return flags;
        }

        function serializeMeetingFlags(flags) {
            var data = {};
            for (var attr in flags) {
                if (attr != 'others') {
                    data[attr] = flags[attr];
                }
            }
            if (flags.others) {
                flags.others.split('&').map(function (nv) {
                    var index = nv.indexOf('=');
                    var attr = decodeURIComponent(index >= 0 ? nv.substr(0, index) : nv).substr(0, 32); // limit size to at most 32
                    var value = index >= 0 ? decodeURIComponent(nv.substr(index + 1)).substr(0, 32) : null;
                    data[attr] = value;
                });
            }
            var existing = deserializeMeetingFlags(configService.getSfuPayload(), true);
            for (var attr1 in data) {
                if (existing[attr1] === data[attr1]) {
                    delete data[attr1];
                }
            }
            return data;
        }

        // save button is clicked.
        function save() {
            // order of these is important.
            self.saveVideoFilter();
            self.saveE2EE();
            self.saveAdvancedSettings();
        }

        function saveAdvancedSettings() {
            var previous = deserializeClientFlags(storageService.get('advancedSettings') || '{}', true);

            ['useWasm', 'others'].forEach(function (attr) {
                if (self.clientFlags[attr] !== undefined && !self.clientFlags[attr]) {
                    // false or 0 or empty string
                    delete self.clientFlags[attr]; // remove if default values.
                }
            });
            ['others'].forEach(function (attr) {
                if (self.meetingFlags[attr] !== undefined && !self.meetingFlags[attr]) {
                    delete self.meetingFlags[attr];
                }
            });

            if (!isEqual(previous, self.clientFlags)) {
                if (isEqual(self.clientFlags, {})) {
                    logService.log('delete localStorage.advancedSettings');
                    storageService.remove('advancedSettings');
                } else {
                    logService.log('localStorage.advancedSettings=' + serializeClientFlags(self.clientFlags));
                    storageService.set('advancedSettings', serializeClientFlags(self.clientFlags));
                }
                if (!Object.keys(self.meetingFlags).length) {
                    $rootScope.$broadcast('advanced-settings-changed');
                } // else it will broadcast this when triggered by server on updated-meeting-sfupayload
            }

            if (Object.keys(self.meetingFlags).length) {
                logService.log('meeting options=' + JSON.stringify(self.meetingFlags));
                var data = serializeMeetingFlags(self.meetingFlags);

                logService.log('send update-meeting-sfupayload data=' + JSON.stringify(data));
                socketService.send({ message: 'update-meeting-sfupayload', data: data });
            }
        }

        function resetToDefaults() {
            logService.log('reset to defaults');

            self.clientFlags = deserializeClientFlags();
            self.options.forEach(function (option, index) {
                if (option.category.match(/\bclient\b/)) {
                    $window.$('#feature-flags #feature-flags-client-' + index).prop('checked', false);
                }
            });
            self.searchFilter = 'Features';
            self.showInlineTooltip = true;
            self.saveClientFlags = true;
            saveAdvancedSettingsBox();
            $window.$('#feature-flags').attr('verbose', '' + self.showInlineTooltip);
            self.showSearchResult();

            analyticsWrapperService.eventTrack('Meeting - feature-flags - reset', { featureFlagsCategory: 'client' });
        }

        // search filter

        function showSearchResult() {
            console.info('show-search-result');
            var words = $window
                .$('#feature-flags #feature-flags-search')
                .val()
                .split(/[,\s;]+/)
                .filter(function (item) {
                    return !!item;
                })
                .map(function (item) {
                    return item.toLowerCase();
                });
            var orlogic = false; // rudimentary OR vs AND (default)
            for (var i = words.length - 1; i >= 0; --i) {
                if (words[i] == 'or') {
                    orlogic = true;
                    words.splice(i, 1);
                }
            }
            var filter = self.searchFilter ? self.searchFilter.toLowerCase() + ',' : '';
            $window.$('#feature-flags div.checkbox-container[keywords]').each(function (index, elem) {
                var keywords = ($(elem).attr('keywords') || '').toLowerCase();
                var match = words.filter(function (word) {
                    return keywords.indexOf(word) >= 0;
                });
                // search for both filter and words match
                if (
                    (filter && !keywords.startsWith(filter)) ||
                    (words.length > 0 && ((!orlogic && match.length < words.length) || (orlogic && match.length == 0)))
                ) {
                    $(elem).attr('search-result', 'false');
                } else {
                    $(elem).removeAttr('search-result');
                }
            });
        }

        // videoFilter specific code.

        self.videoFilterValue = null;
        self.videoFilterEnabled = false;

        self.initVideoFilter = initVideoFilter;
        self.onVideoFilterToggled = onVideoFilterToggled;
        self.onVideoFilterSelect = onVideoFilterSelect;
        self.onVideoFilterFileSelect = onVideoFilterFileSelect;
        self.saveVideoFilter = saveVideoFilter;
        self.initE2EE = initE2EE;
        self.saveE2EE = saveE2EE;

        function initVideoFilter() {
            // video filter specific
            self.videoFilterValue = storageService.get('videoFilter');
            if (self.videoFilterValue && self.videoFilterValue.startsWith('change-bg:blob:')) {
                self.videoFilterValue = null; // do not load blob url from last time.
            }
            self.videoFilterEnabled = !!self.videoFilterValue;
        }

        function saveVideoFilter() {
            var previous = storageService.get('videoFilter');
            if (previous !== self.videoFilterValue) {
                logService.log('saveVideoFilter ' + !!previous + ' => ' + !!self.videoFilterValue);
                if (self.videoFilterValue) {
                    storageService.set('videoFilter', self.videoFilterValue);
                } else {
                    storageService.remove('videoFilter');
                }
                $rootScope.$broadcast('video-filter-changed', {
                    oldValue: previous,
                    newValue: self.videoFilterValue
                });
            }
        }

        function onVideoFilterToggled() {
            if (self.videoFilterEnabled) {
                self.videoFilterValue = 'blur-bg';
            } else {
                self.videoFilterValue = null;
            }
        }

        function onVideoFilterSelect() {
            self.videoFilterValue = 'remove-bg';
            self.videoFilterEnabled = true;
            digest();

            $window.$('#video-background-file-upload').click();
        }

        function onVideoFilterFileSelect() {
            var file = $window.$('#video-background-file-upload')[0].files[0];
            if (file) {
                if (file.type == 'video/mp4') {
                    // this won't be available next time.
                    self.videoFilterValue = 'change-bg:' + URL.createObjectURL(file);
                    logService.log('changed video filter to ' + self.videoFilterValue.substr(0, 100));
                    self.videoFilterEnabled = true;
                    digest();
                } else if (file.type && file.type.startsWith('image/')) {
                    var image = new Image();
                    image.onload = function (event) {
                        var w = image.naturalWidth || image.width,
                            h = image.naturalHeight || image.height;
                        var canvas = document.createElement('canvas');
                        var cw = (canvas.width = 640);
                        var ch = (canvas.height = 360);
                        if (w && h) {
                            // preserve the aspect ratio
                            if (w / h >= cw / ch) {
                                cw = canvas.width = (ch * w) / h; // increase width, keep height same
                            } else {
                                ch = canvas.height = (cw * h) / w; // increase height, keep width same.
                            }
                        }
                        canvas.getContext('2d').drawImage(image, 0, 0, w, h, 0, 0, cw, ch);

                        var dataURL = canvas.toDataURL('image/jpeg');
                        self.videoFilterValue = 'change-bg:' + dataURL;
                        self.videoFilterEnabled = true;

                        digest();
                    };
                    image.src = URL.createObjectURL(file);
                } else {
                    logger.error('onVideoFilterFileSelect', 'only video or image file can be selected', file.type);
                    self.videoFilterEnabled = false;
                    self.videoFilterValue = '';
                }
                $window.$('#video-background-file-upload').val('');
            }
        }

        function saveE2EE() {
            if (
                Object.keys(self.meetingFlags).find(function (prop) {
                    return prop === 'e2eeEnabled';
                })
            ) {
                var e2eeEnabled = self.meetingFlags.e2eeEnabled === 'true';

                $rootScope.$broadcast('e2ee-toggled', {
                    value: e2eeEnabled
                });
            }
        }

        // compare two objects and their properties.
        function isEqual(a, b) {
            var aProps = Object.getOwnPropertyNames(a);
            var bProps = Object.getOwnPropertyNames(b);

            if (aProps.length != bProps.length) {
                return false;
            }

            for (var i = 0; i < aProps.length; i++) {
                var propName = aProps[i];
                if (a[propName] !== b[propName]) {
                    return false;
                }
            }

            return true;
        }

        // cancel button clicked, reset the settings.
        function cancel() {
            self.initSettings();
        }

        //Closed via Cancel or Save buttons
        function closeModal(applyChanges) {
            logService.log('featureFlagsCtrl - closing modal... applying changes:', applyChanges);

            if (applyChanges) {
                self.isSaving = true;
                self.save();
            }

            // TODO: need a better way than using timeout.
            $timeout(function () {
                $rootScope.$broadcast('feature-flags-modal-closed', {
                    applyChanges: applyChanges
                });

                self.isSaving = false;
                digest();
            }, 1000);
        }

        function sendFeedback(div, title) {
            console.info('feature-flags send-feedback - ' + title);
            var old = $window.$('div.feature-flags-feedback[state="input"]');
            if (old && old.length > 0) {
                old.attr('state', 'closing');
                $timeout(function () {
                    old.remove();
                }, 300);
            }

            var labels =
                '<div class="labels"><span>1</span><span>2</span><span>3</span><span>4</span><span>5</span></div>';
            var feedback = $window.$(
                '<div class="feature-flags-feedback">' +
                    '<span class="title">Feedback for "' +
                    title +
                    '"</span>' +
                    '<div class="rating">' +
                    '<div>' +
                    '<label>I use this <span name="usethis"></span></label>' +
                    '<input name="usethis" type="range" min="1" max="5" value="3" tickmarks title="slide or click to select" />' +
                    labels +
                    '</div>' +
                    '<div>' +
                    '<label>I like this <span name="likethis"></span></label>' +
                    '<input name="likethis" type="range" min="1" max="5" value="3" tickmarks title="slide or click to select"/>' +
                    labels +
                    '</div>' +
                    '</div>' +
                    '<textarea placeholder="More comments here..."></textarea>' +
                    '<div class="buttons"><button class="cancel btn btn-link waves-effect">Cancel</button>&nbsp;<button class="submit btn im-btn-success waves-effect">Submit</button></div>' +
                    '<div class="thankyou">Thank you for your valuable feedback!</div>' +
                    '</div>'
            );

            $window.$(div).before(feedback);

            var usethis = ['never', 'rarely', 'sometimes', 'many times', 'very often'];
            var likethis = ['really hate it', 'hate it', 'indifferent', 'love it', 'really love it'];

            var updateValue = function (event) {
                var name = event.currentTarget.getAttribute('name');
                value = event.currentTarget.value;
                event.currentTarget.parentNode.setAttribute('value', value);
                value = (name == 'usethis' ? usethis : likethis)[parseInt(value) - 1];
                feedback.find('span[name="' + name + '"]').text(value);
                event.currentTarget._changed = true;
            };
            feedback.find('input').click(updateValue);
            feedback.find('input').change(updateValue);

            feedback.find('button.cancel').click(function (event) {
                if (feedback.attr('state') !== 'input') {
                    return;
                }

                feedback.attr('state', 'closing');
                $timeout(function () {
                    feedback.remove();
                }, 300);
            });

            feedback.find('button.submit').click(function (event) {
                if (feedback.attr('state') !== 'input') {
                    return;
                }

                var input1 = feedback.find('input[name="usethis"]')[0];
                var input2 = feedback.find('input[name="likethis"]')[0];
                var text = feedback.find('textarea')[0];
                var data = {
                    featureFlagsTitle: title,
                    featureFlagsUseThis: input1._changed ? input1.value : null,
                    featureFlagsLikeThis: input2._changed ? input2.value : null,
                    featureFlagsFeedback: text.value || null
                };

                logService.log('sending feature-flags feedback ' + JSON.stringify(data));
                analyticsWrapperService.eventTrack('Meeting - feature-flags - feedback', data);

                feedback.attr('state', 'thankyou');
                $timeout(function () {
                    feedback.attr('state', 'closing');
                    $timeout(function () {
                        $window.$('div.feature-flags-feedback').remove();
                    }, 300);
                }, 2000);
            });

            $timeout(function () {
                feedback.attr('state', 'input');
            });
        }

        function printAllFlags() {
            var w = window.open('', '_blank');
            var style =
                'body { font-family: sans-serif; } .feature-flags-title, .checkbox-label { font-weight: bold; margin-top: 20px; display: block; } img, input { display: none; } .checkbox-container[keywords*="features,"] .checkbox-label:after { content: " (feature)"; }';
            var text = $window.$('#feature-flags .modal-body').html();
            w.document.write(
                '<head><title>Labs Playground</title><style type="text/css">' +
                    style +
                    '</style></head><body><h1>Labs Playground</h1>' +
                    text +
                    '</body>'
            );
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }
    }
]);
